// extracted by mini-css-extract-plugin
export default {"description":"_2td712tR4jKeAZ3Y4EHZn1"};